<template>
  <div>
    <div >
      <div >
        <b-row class="align-center">
            <b-col v-if="!HasParticipants" class="text-info"><i> {{$t('connector.label.nodata')}}</i></b-col>
          </b-row>
         <b-button v-if="HasParticipants" v-b-toggle="'list-invisible-residents'" class="m-1" variant="info">
          <span class="when-open"
            ><font-awesome-icon :icon="['fas', 'chevron-up']" />&nbsp;</span
          >
          <span class="when-closed"
            ><font-awesome-icon :icon="['fas', 'chevron-down']" />&nbsp;</span
          >
          {{ $t("connector.label.list_resident") }}
        </b-button>
        <b-button v-if="HasImport" 
          variant="warning"
          @click="getFromAPI"
          >{{$t('connector.btn.get_from_api')}}</b-button>
          &nbsp;
          <b-badge variant="dark" v-if="residents === null">{{$t('connector.label.nodatanetsoins')}}</b-badge>
          <b-badge variant="success" v-if="residents">{{ $t("connector.label.nb_residents_netsoins", [residents.length])}} </b-badge>
          <b-button v-if="residents && !useProxy && connector === 'NETSOIN'" @click="GetLink()">
            <font-awesome-icon :icon="['fas', 'download']" />
              &nbsp;{{ $t("btn.download") }}
          </b-button>
        <b-collapse v-model="listVisible" id="list-invisible-residents">
          <b-table
            :fields="fields"
            :items="participants"
            small
            responsive="sm"
            :tbody-tr-class="rowClass"
          >
            <template #cell(saved)="row">
               <b-col> 
                  <font-awesome-icon  v-if="row.item.saved" :icon="['fas', 'check-square']" />
                  <font-awesome-icon v-else :icon="['fas', 'square']" />
               </b-col>
            </template>
            <template #cell(pare_id)="row">
              <b-col>{{ row.item.pare_id }}</b-col>
            </template>            
            <template #cell(par_is_male)="row">
              <b-col v-if="row.item.par_is_male"
                ><font-awesome-icon :icon="['fas', 'mars']" class="male"
              /></b-col>
              <b-col v-else
                ><font-awesome-icon :icon="['fas', 'venus']" class="female"
              /></b-col>
            </template>
            <template #cell(par_lastname)="row">
              <b-col>{{ row.item.par_lastname }}</b-col>
            </template>
            <template #cell(par_firtsname)="row">
              <b-col>{{ row.item.par_firtsname }}</b-col>
            </template>
            <template #cell(par_birthday)="row">
              <b-col v-if="row.item.par_birthday != null">{{
                row.item.birthyear
              }}</b-col>
              <b-col v-else><i>{{$t('label.undefine')}}</i></b-col>
            </template>            
            <template #cell(ext_uri)="row">
              <b-col>
                <b-input-group size="sm">
                <b-form-select id="uriT" 
                  v-b-tooltip.hover :title="(row.item.ext_uri === null) ? '' : row.item.ext_uri"
                  :disabled="row.item.ext_uri === null && !row.item.pare_is_enable" 
                  v-model="row.item.ext_uri" @input="setModified($event, row.item)">
                  <option :value="null" disabled>{{$t('connector.option.resident')}}</option>
                  <option :key="resident.Uri" v-for="resident in residents" :value="resident.Uri" >
                    {{ resident.Fullname }}
                  </option>
                </b-form-select>
                </b-input-group>
              </b-col>
            </template>
            <template #cell(update)="row">
              <b-row class="details">
                <b-col>
                  <b-button
                  v-b-tooltip.hover :title="$t('connector.tooltip.unmap')"
                  size="sm"
                  @click="Reset(row.item)"
                  :disabled="!(SaveEnabled )"
                  variant="outline-danger"
                  >X
                  </b-button>
                  <span class="d-inline-block" tabindex="0"
                  v-b-tooltip.hover :title="!(SaveEnabled && row.item.modified) ? '' : $t('connector.tooltip.cancel')"
                  >
                  <b-button
                  class="editbtn"
                  size="sm"
                  @click="Undo(row.item)"
                  :disabled="!(SaveEnabled && row.item.modified)"
                  >

                    <font-awesome-icon :icon="['fa', 'undo']" />
                  </b-button>
                  </span>
                  <b-button
                    v-b-tooltip.hover :title="!(SaveEnabled && row.item.modified) ? '' : $t('btn.save')"
                    size="sm"
                    :disabled="!(SaveEnabled && row.item.modified)"
                    @click="SaveMapping(row.item)"
                    :variant="(row.item.modified)? 'danger' :'secondary'"
                    class="editbtn"
                    >
                    <font-awesome-icon :icon="['fas', 'save']" />
                    </b-button>
                </b-col>
              </b-row>
            </template>
          </b-table>
        </b-collapse>
      </div>
    </div>
  </div>
</template>

<script>
import { normalizeSync } from "normalize-diacritics";
import { MappedParticipants, SetParticipantUri } from "../../services/participants";
import { Residents, Links} from "../../services/netsoins"
import ApiTitan, { normalizeTitanResident } from "../../services/titan";
import ApiNetsoins from "../../services/proxyNetsoins";

export default {
  name: "ListResidents",
  props: {
    keyapi: { 
      type: String,
      default: null 
    },
    urlapi: { 
      type: String, 
      default: null 
    },
    config: {
      type: Object,
      default() { return {} },
    },
    connector: {
      type: String,
      default: 'NETSOIN',
    },
    esta: { type: Number, default: null},
    cnt: { type: Number, default: null},
    ctx: { type: Number, default: null},
    useProxy: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      title:  this.$i18n.t('connector.label.list_resident'),
      fields: [
        {
          saved: {
            label: this.$i18n.t('label.saved') ,
            sortable: true,
            tdClass: 'align-middle',
          }
        },
        {
          par_lastname: {
            label: this.$i18n.t('label.name'),
            sortable: true,
            tdClass: "align-middle  text-left",
          },
        },
        {
          par_firstname: {
            label: this.$i18n.t('label.firstname') ,
            sortable: true,
            tdClass: "align-middle  text-left",
          },
        },
        {
          par_is_male: {
            label: this.$i18n.t('label.gender'),
            sortable: true,
            tdClass: "align-middle",
          },
        },
        {
          par_birthday: {
            label: this.$i18n.t('label.birthday') ,
            sortable: true,
            tdClass: "align-middle  text-right",
          },
        },
        {
          ext_uri: {
            label: this.$i18n.t('connector.label.uriterranga') ,
            sortable: true,
            tdClass: "align-middle",
          },
        },
        {
          pare_id: {
            label: this.$i18n.t('label.identifiant') ,
            sortable: true,
            tdClass: "align-middle",
          },
        },
        {
          update: {
            label: this.$i18n.t('label.action') ,
            sortable: false,
            tdClass: "align-middle",
          },
        },        
      ],
      participants: null,
      residents: null,
      listVisible: false,
    };
  },
  async mounted() {
    this.getParticipants();
    this.listVisible = this.HasParticipants;

  },
  methods: {
    async SaveMapping(item){
      item.saved = await SetParticipantUri(this.esta, this.cnt, item.pare_id, item.ext_uri)
      if (item.saved) {
        item.old_uri = item.ext_uri;
        item.modified = false;
      }
    },
    async getParticipants() {
      this.participants = await MappedParticipants(this.esta, this.cnt);
    },
    rowClass(item, type) {
      if (!item || type !== "row") return;
      if (!item?.pare_is_enable) return "notenabled"
      if (item.saved) return "gosted";
      if (item?.ext_uri !== ""  ) return "uncompleted";

    },
    checkMapping(){
      this.participants.map(p => {
        p.modified = false;
        p.old_uri = p.ext_uri;
        if (p.ext_uri === null){
          p.ext_uri = this.checkParticipant(p.par_lastname, p.par_firstname);
          if (p.ext_uri) {
            p.modified = true;
            p.saved = false;
          }
        }
        return p;
      })
    },
    checkParticipant(nom, prenom) {
      // Force la normalisation car différent selon la source
      let vnom = normalizeSync(nom);
      let vprenom = normalizeSync(prenom);

      const i = this.residents.find((r) => {

          const textnom = normalizeSync(r.Nom);
          if (vnom.includes(textnom)){
            const textprenom = normalizeSync(r.Prenom);
            return vprenom.includes(textprenom);
          }
          return false;
        
      });
      if (i) return i.Uri;
      return null;
    },
    setResidents(result) {
      this.residents = result.data.map((m) => {
        return {
          Nom: m.Nom,
          Prenom: m.Prenom,
          Fullname: `${m.Nom} ${m.Prenom}`,
          DateNaissance: m.DateNaissance,
          Enabled: m.Actif === "1",
          Uri: m.Uri
        };
      });
      this.checkMapping();
    },
     async getFromAPI(){
      let values = [];
      if (this.connector === 'NETSOIN') {
        if (this.useProxy) {
          const api = new ApiNetsoins(this.keyapi, this.urlapi);
          values = await api.getResidents();
        }
        else {
          values = await Residents({uri:this.urlapi, key:this.keyapi});
        }
      } else if (this.connector === 'TITAN') {
        const api = new ApiTitan(this.config.apilogin, this.config.apipassword, this.config.apikey, this.config.apiurl, this.config.ext_uri);
        values = (await api.getResidents())
          .map(normalizeTitanResident)
          .sort((a, b) => a.Fullname.toLowerCase().localeCompare(b.Fullname.toLowerCase()));
      }
      if (values) {
        this.setResidents({data: values});
      }
    },
    setModified(value,item){
      item.modified = (item.old_uri !== item.ext_uri);
      item.saved = !(item.old_uri !== item.ext_uri );
    },
    Undo(item){
      item.ext_uri = item.old_uri;
      item.modified = false;
      item.saved = (item.old_uri === item.ext_uri && item.ext_uri !== null);
    },
    Reset(item){
      item.ext_uri = null;
      item.modified = (item.old_uri !== item.ext_uri);
      item.saved = !(item.old_uri !== item.ext_uri );      
    },
    GetLink(){
      var link = Links("residents", {uri:this.urlapi, key:this.keyapi});
      if (link) {
        Object.assign(document.createElement('a'), { target: '_blank', href: link }).click();
      }
    }    
    
  },
  computed:{   
    HasImport(){
      return (this.keyapi !== null && this.urlapi !== null) || (
        this.config && this.config.apilogin !== null && this.config.apipassword !== null && this.config.apikey !== null && this.config.apiurl !== null && this.config.ext_uri !== null
        ) && this.HasParticipants;
    },
    HasParticipants() {
      return !!this.participants;
    },
    SaveEnabled() {
      return (!!this.ctx && this?.ctx > 0);
    }
}
};
</script>
<style >
.notenabled {
  color: lightgray;
  background-color: gray;
  text-decoration-line: line-through;
}
.gosted {
  color: grey;
  background-color: lightgray;
}
.uncompleted {
  color: red;
  background-color: rgb(247, 222, 222);
}
.details {
  display: flex;
}
.editbtn {
  margin-left: 0.2rem;
}
</style>
